import { Vue } from 'vue-property-decorator';
import VueRouter from 'vue-router';
import { RouterPath } from '../shared/enums';
import { homeModule } from '../module-home';
import { loginModule } from '../module-login';
import { invoiceModule } from '../module-invoice';
import { errorsModule } from '../module-errors';
import { permissionModule} from '../module-permission';
import { dashboardModule } from '../module-dashboard';
import Page404Component from '../module-errors/components/pages/page-404';
import store from '../store';
import {AuthenticationService} from '../modules/authentication/services/authentication.service';

Vue.use(VueRouter);

export default function router() {
    let router: VueRouter;

    router = new VueRouter({
        mode: 'history',
        routes: [
            {
                path: RouterPath.ROOT,
                redirect: RouterPath.HOME
            },
            ...homeModule.routes(),
            ...loginModule.routes(),
            ...invoiceModule.routes(),
            ...errorsModule.routes(),
            ...permissionModule.routes(),
            ...dashboardModule.routes(),
            { path: '*', component: Page404Component }
        ],
        scrollBehavior (to, from, savedPosition) {
            return new Promise((resolve, reject) => {
              setTimeout(() => {
                resolve({ x: 0, y: 0 });
              }, 500);
            });
          }
    });

    router.beforeEach((to, from, next) => {
        const requiresAuth = !to.matched.some(record => record.meta.nonRequiresAuth);
        const isLoginPage = to.matched.some(record => record.meta.loginPage);
        const hasJWT = localStorage.getItem(AuthenticationService.TOKEN_KEY);
        const accessRole = to.meta.role ? to.meta.role : null;
        store.commit('ui/sidebarVisibility', true);


        if (!hasJWT && !requiresAuth) {
            next();
            return;
        }

        if (hasJWT) {
            store.dispatch('auth/checkToken').then(response => {
                if (!response && !requiresAuth) {
                    next();
                    return;
                }

                if (response) {
                    const roles = store.getters['auth/roles'];
                    if (!accessRole || roles.indexOf(accessRole) > -1) {
                        next();
                        return;
                    }

                    next({path: RouterPath.ERROR_WORKSPACE, replace: true});
                    return;
                }

                if (requiresAuth) next({path: RouterPath.AUTH_LOGIN, replace: true});
            }).catch(error => {
                next(RouterPath.ERROR);
            });
        } else {
            next({path: RouterPath.AUTH_LOGIN, replace: true});
        }
    });

    return router;
}
